import React, { useState } from 'react';
import {
  Modal,
  Box,
  SpaceBetween,
  Button,
  FormField,
  Input,
  Alert
} from '@cloudscape-design/components';
import { signIn, confirmSignIn } from 'aws-amplify/auth';

const LoginModal = ({ visible, onDismiss, onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    setLoading(true);
    setError('');

    try {
      const result = await signIn({ username, password });
      
      if (result.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        const newPassword = prompt('Veuillez entrer un nouveau mot de passe (min 8 caractères, 1 majuscule, 1 chiffre):');
        if (!newPassword) {
          setError('Nouveau mot de passe requis');
          return;
        }
        
        await confirmSignIn({ challengeResponse: newPassword });
      }
      
      onLogin();
      onDismiss();
    } catch (error) {
      setError(error.message || 'Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header="Login to Title Manager"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              Cancel
            </Button>
            <Button 
              variant="primary" 
              onClick={handleLogin}
              loading={loading}
              disabled={!username || !password}
            >
              Login
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        {error && (
          <Alert type="error" dismissible onDismiss={() => setError('')}>
            {error}
          </Alert>
        )}
        
        <FormField label="Username">
          <Input
            value={username}
            onChange={({ detail }) => setUsername(detail.value)}
            placeholder="Enter username"
          />
        </FormField>

        <FormField label="Password">
          <Input
            value={password}
            onChange={({ detail }) => setPassword(detail.value)}
            type="password"
            placeholder="Enter password"
          />
        </FormField>
      </SpaceBetween>
    </Modal>
  );
};

export default LoginModal;